export const stuffLoading = (state) => state.stuff.loading;
export const getStuffData = (state) => state.stuff.stuff;
export const getStuffKit = (state) => state.stuff.selectedKit;
